import { render, staticRenderFns } from "./addAddressdialog.vue?vue&type=template&id=b2283362&"
import script from "./addAddressdialog.vue?vue&type=script&lang=js&"
export * from "./addAddressdialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports